import { GatsbyImage, getImage, StaticImage } from 'gatsby-plugin-image';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { Gallery } from '../../atoms/Gallery';
import React from 'react';
import { GatsbyGalleryPlaceholderElement } from './gatsbyGalleryPlaceholderElement';
import * as PropTypes from 'prop-types';
import Chip from '@mui/material/Chip';
import { createIntl, IntlProvider } from 'react-intl';
import { LocaleContext } from '../../../contexts/language';
import { hexToRgbA } from '../../../functions/hexToRgbA';
import { selectTextColor } from '../../../functions/selectTextColor';
import Typography from '@mui/material/Typography';
import GalleryItem from '../../atoms/GalleryItem';
import CancelIcon from '@mui/icons-material/Cancel';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import PlaylistAddCheckCircleIcon from '@mui/icons-material/PlaylistAddCheckCircle';

import ar from './ar.json';
import en from './en.json';

const languages = {
  ar,
  en
};


export const CarImageGallery = ({ images, stockAvailability, colorName, colorCode }) => {
  const [fullScreen, setFullscreen] = React.useState(false);
  const localeConfig = React.useContext(LocaleContext);

  const intl = createIntl({
    locale: localeConfig.lang,
    messages: languages[localeConfig?.lang] || languages.en
  });
  const colorWidget = colorName ? (<Box
    style={{
      position: 'absolute',
      right: 0,
      top: 0,
      bottom: 0,
      left: '66%',

      backgroundColor: colorCode ? hexToRgbA(colorCode, 0.75) : hexToRgbA('#fff', 0.75),
      color: colorCode ? selectTextColor(colorCode, '#fff', '#3a3a3c') : '#3a3a3c'
    }}
  >
    <Stack sx={{ justifyContent: 'center', height: '100%' }}>
      <Stack direction={'row'} sx={{ justifyContent: 'center',p:1 }}>
        <Typography component="span" sx={{ textWrap:'wrap', fontSize: '1.2rem', fontWeight: '700' }}>{colorName}</Typography>
      </Stack>
    </Stack>
  </Box>) : null;
  const availabilityWidget = (
    <Stack
      direction={'row'}
      sx={{ zIndex: 10, position: 'absolute', top: '0px', alignItems: 'center', width: '100%', m: 0 }}
    >
      <Box
        sx={{ m: 1 }}
      >
        {stockAvailability === 'UNKNOWN' && (
          <Chip
            // color={'primary'}
            sx={{
              '& .MuiChip-label': {
                overflow: 'visible'
              },
              backgroundColor:'#ffffffc0',
              color: '#3a3a3c'

            }}
            icon={<ContactSupportIcon />}
            label={intl.formatMessage({
              id: 'FavoriteAndAvailability.EnquireForAvailability',
              defaultMessage: 'Enquire for Availability'
            })}
          />
        )}
        {stockAvailability === 'IN_STOCK' && (
          <Chip
            color={'success'}
            icon={<ContactSupportIcon />}
            label={intl.formatMessage({
              id: 'FavoriteAndAvailability.IN_STOCK',
              defaultMessage: 'In Stock'
            })}

          />
        )}
        {stockAvailability === 'WAIT_LIST' && (
          <Chip
            color={'warning'}
            icon={<PlaylistAddCheckCircleIcon />}
            label={intl.formatMessage({
              id: 'FavoriteAndAvailability.WAIT_LIST',
              defaultMessage: 'Waiting List'
            })}
          />
        )}
        {stockAvailability === 'NOT_AVAILABLE' && (
          <Chip
            color={'error'}
            icon={<CancelIcon />}
            label={intl.formatMessage({
              id: 'FavoriteAndAvailability.NOT_AVAILABLE',
              defaultMessage: 'Out Of Stock'
            })}
          />
        )}
      </Box>
    </Stack>
  );
  const emptyImageSet = [{
    original: 'not_image',
    thumbnail: 'not_image',
    renderThumbInner: () => (
      <StaticImage
        sx={{ borderRadius:'15px' }}
        src={'./images/galleryPlaceholder.png'}
        // height={200}
        // width={200}
        layout={'fullWidth'}
      />
    ),
    renderItem: () => {
      return (
        <GalleryItem fullScreen={fullScreen}>
          {availabilityWidget}
          <GatsbyGalleryPlaceholderElement />
          {colorWidget}
        </GalleryItem>
      );
    }
  }];
  const allImages = images && images.length ? images : [];

  const imageSet = (allImages && allImages?.length) ? allImages?.map((props) => {
    const { fullImage, thumbnail, regularImage } = props || {};
    return {
      thumbnailHeight:'100px',
      thumbnailWidth:'100px',
      original: 'not_image',
      thumbnail: 'not_image',
      renderThumbInner: () =>
        <GatsbyImage alt="" style={{ objectFit: 'cover', borderRadius:'15px' }}
          image={getImage(thumbnail)} />,

      renderItem: () => {
        return <IntlProvider locale={localeConfig?.lang} messages={languages[localeConfig?.lang] || languages.en}>
          <GalleryItem fullscreen={fullScreen || undefined}>
            {availabilityWidget}
            {/*{(!stockAvailability && img.trimLevel) ? <GalleryItemHeader>  <IntlProvider locale={localeConfig?.lang} messages={languages[localeConfig?.lang] || languages.en}><FormattedMessage id={'imageGallery.header'} defaultMessage={'{year} Model ({generation})'} values={{ year:img.trimLevel.modelYear, generation: img.trimLevel.subModel.generation.translatedName||img.trimLevel.subModel.generation.name }}/> </IntlProvider> </GalleryItemHeader> : null}*/}
            <GatsbyImage alt={''} style={{ height: '100%', width: '100%', objectFit: 'cover', borderRadius:'15px' }}
              image={fullScreen ? getImage(fullImage) : getImage(regularImage)} />
            {colorWidget}
          </GalleryItem>
        </IntlProvider>;
      }
    };
  }) : [];


  return (
    <Gallery
      fullScreen={fullScreen}
      onScreenChange={setFullscreen}
      useBrowserFullscreen={true}
      items={imageSet.length ? imageSet : emptyImageSet}
    />
  );
};

CarImageGallery.propTypes = {
  stockAvailability: PropTypes.string,
  images: PropTypes.arrayOf(PropTypes.shape({
    thumbnail: PropTypes.shape({}),
    regularImage: PropTypes.shape({}),
    fullImage: PropTypes.shape({}),
    description: PropTypes.string
  })),
  colorName: PropTypes.node,
  colorCode: PropTypes.string
};

CarImageGallery.defaultProps = {
  fullScreen: false,
  images: []
};
export default CarImageGallery;
